module.exports = __webpack_public_path__ + "static/media/6.465b1cf7.jpg";